// @ts-check

import React from "react";

import { BlockStack, Card, Text, InlineStack, Box, Button, ButtonGroup, SkeletonDisplayText, SkeletonBodyText, Icon, Tooltip } from "@shopify/polaris";
import { CheckIcon, LogoMetaIcon, XSmallIcon } from "@shopify/polaris-icons";

export const PricingCard = ({
  loading,
  title,
  price,
  frequency,
  features = [],
  button = {},
}) => {
  const { content, ...restButton } = button;

  let titleToRender = (
    <SkeletonDisplayText size="small" />
  );
  if (!loading) {
    titleToRender = (
      <Text as="h3" variant="headingLg">
        {title}
      </Text>
    );
  }

  let priceToRender = (
    <SkeletonDisplayText size="small" />
  );
  if (typeof price === "number") {
    let frequencyToRender;
    if (frequency) {
      frequencyToRender = (
        <Box paddingBlockEnd="200">
          <Text as="span" variant="bodySm">/ {frequency}</Text>
        </Box>
      );
    }

    priceToRender = (
      <InlineStack blockAlign="end" gap="100" align="start">
        <Text as="h2" variant="heading2xl">
          ${price}
        </Text>

        {frequencyToRender}
      </InlineStack>
    );
  }

  let featuresToRender;
  if (loading) {
    featuresToRender = Array.from({ length: 5 }, (v, i) => (
      <SkeletonBodyText lines={1} key={i} />
    ));
  } else {
    featuresToRender = features.map(({ text, enabled, icon, description }, index) => {
      let iconToRender = (
        <Icon
          source={XSmallIcon}
          tone="subdued"
        />
      );

      if (enabled) {
        let source = CheckIcon;
        if (icon === "facebook") {
          source = LogoMetaIcon;
        }

        iconToRender = (
          <Icon
            source={source}
            tone="base"
          />
        );
      }

      let textToRender = (
        <Text tone={enabled ? undefined : "subdued"} as="p" variant="bodyMd" key={index}>
          {text}
        </Text>
      );
      if (description) {
        textToRender = (
          <Tooltip content={description} dismissOnMouseOut>
            {textToRender}
          </Tooltip>
        );
      }

      return (
        <div style={{ display: "grid", gridTemplateColumns: "min-content 1fr", gap: "0.4rem" }} key={text}>
          <div>
            {iconToRender}
          </div>
          {textToRender}
        </div>
      )
    });
  }

  return (
    <div
      style={{
        borderRadius: ".75rem",
        position: "relative",
        zIndex: "0",
      }}
    >
      <Card>
        <BlockStack gap="400">
          <BlockStack gap="200" align="start">
            {titleToRender}
          </BlockStack>

          {priceToRender}

          <BlockStack gap="100">
            {featuresToRender}
          </BlockStack>

          <Box paddingBlockStart="200">
            <ButtonGroup fullWidth>
              <Button {...restButton} disabled={loading || restButton.disabled}>{content}</Button>
            </ButtonGroup>
          </Box>
        </BlockStack>
      </Card>
    </div>
  );
};
